import { render, staticRenderFns } from "./nav_iconF.vue?vue&type=template&id=fba544e6&scoped=true"
import script from "./nav_iconF.vue?vue&type=script&lang=js"
export * from "./nav_iconF.vue?vue&type=script&lang=js"
import style0 from "./nav_iconF.vue?vue&type=style&index=0&id=fba544e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba544e6",
  null
  
)

export default component.exports